import SitrepManager from 'components/DisasterGPT/SitrepManager';
import { useNavigate } from 'react-router';

const Sitreps: React.FC = () => {
  const navigate = useNavigate();
  const handleSitrepSelect = (sitrepId: UUID) => {
    navigate(`/sitreps/${sitrepId}`);
  };

  return <SitrepManager handleSitrepSelect={handleSitrepSelect} />;
};

export default Sitreps;
